import React from 'react';
import { RouteComponentProps } from 'react-router';
import { observer, inject } from 'mobx-react';
import { AgendamentoStore, AGENDAMENTO_STORE, DataHoraValidator, MonografiaModel, JustificativaValidator } from '../../Store';
import AgendamentoCard from './Components/AgendamentoCard';
import DetalhesAgendamentoCard from './Components/DetalhesAgendamentoCard'
import { withStateCard, Toast, ToastType, TutorialButtonAndBackButton } from '../../Components';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import styled from 'styled-components';
import { format } from 'date-fns';
import JustificativaDaExclusaoModal from './Components/JustificativaDaExclusaoModal';
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf";

interface IProps extends RouteComponentProps<{ id: string }> {
  [AGENDAMENTO_STORE]: AgendamentoStore;
}

interface IState {
  loadingMessage: string;
  modalIsOpen: boolean;
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const AgendamentoBancaPageWithState = withStateCard(Container);

const StyledText = styled.span`
  padding: 5px;
`;

@inject(AGENDAMENTO_STORE)
@observer
export default class AgendamentoBancaPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loadingMessage: 'Loading ...',
      modalIsOpen: false,
    };
  }

  agendar = async () => {
    this.setState({ loadingMessage: 'Pesquisando disponibilidade de sala...' });

    const store = this.props[AGENDAMENTO_STORE];
    const { dia, hora, setValidationError } = store;
    const { id } = this.props.match.params;
    const { history } = this.props;
    let dataHora = dia + ' ' + hora;

    const error = DataHoraValidator.getErrors({ dataHora });
    const salaInvalida = !store.localId;
    if (error || salaInvalida) {
      setValidationError({
        ...(error || {}),
        ...(salaInvalida ? { localId: ['Sala é obrigatória'] } : {})
      });
      return;
    }

    setValidationError({});
    await store.confirmarAgendamentoBanca(Number(id));
    if (store.agendamentoRealizado) {
      history.push('/funcionario');
    }
  };

  excluiAgendamento = () => {
    this.setState({ loadingMessage: 'Excluindo Agendamento...' });
    const store = this.props[AGENDAMENTO_STORE];
    const { justificativaExclusao, setJustificativaValidationError } = store;
    const { id } = this.props.match.params;

    const error = JustificativaValidator.getErrors({ justificativa: justificativaExclusao });
    if (error) {
      setJustificativaValidationError(error);
      return;
    }

    setJustificativaValidationError({});
    store.cancelaAgendamentoBanca(Number(id));
    this.setState({ modalIsOpen: false });
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const store = this.props[AGENDAMENTO_STORE];
    const { name, value } = e.target;
    store.updateAttribute(name, value);
  };

  componentDidMount() {
    const id = Number(this.props.match.params.id);
    const store = this.props[AGENDAMENTO_STORE];
    store.getAgendamentoAndLocais(id);
  }

  onResumeClick = () => {
    window.open(Tutorial_Funcionario);
  }

  render() {
    const store = this.props[AGENDAMENTO_STORE];
    const monografia = store.monografia as MonografiaModel;
    const {
      dataSugerida,
      dia,
      hora,
      localId,
      linkEvento,
      locais,
      agendamentoRealizado,
      agendamentoValidationError,
      agendamentoState,
      justificativaExclusao,
      justificativaValidationError
    } = store;

    const membros = monografia.banca.map(b => b.membro);

    const diaValue = monografia.agendamento
      ? format(monografia.agendamento!.dataInicio, 'YYYY-MM-DD')
      : dia;
    const horaValue = monografia.agendamento
      ? format(monografia.agendamento!.dataInicio, 'HH:mm')
      : hora;
    const linkEventoValue = monografia.agendamento
    ? monografia.agendamento!.linkEvento:linkEvento;
    const localIdValue = monografia.agendamento
      ? (monografia.agendamento.localId || '')
      : localId;

    const { history } = this.props;

    return (
      <AgendamentoBancaPageWithState
        state={agendamentoState}
        loading={this.state.loadingMessage}
      >
        <TutorialButtonAndBackButton 
          openTutorial = {this.onResumeClick}
          voltar= {() => history.push('/funcionario')}
        />
        {!agendamentoValidationError && (agendamentoRealizado || monografia.agendamento) &&
          <Toast type={ToastType.success}>
            <StyledText>Agendamento realizado</StyledText>
          </Toast>
        }
        <GlobalErrorToast messages={agendamentoValidationError && (agendamentoValidationError.global)} />
        <JustificativaDaExclusaoModal
          isOpen={this.state.modalIsOpen}
          outterClick={() => this.setState({ modalIsOpen: false })}
          onTextChange={e => store.updateAttribute('justificativaExclusao', e.target.value)}
          errors={justificativaValidationError}
          texto={justificativaExclusao}
          confirmar={this.excluiAgendamento}
        />
        <AgendamentoCard
          monografiaid={monografia.id}
          dataSugerida={dataSugerida}
          dia={diaValue}
          hora={horaValue}
          linkEvento={linkEventoValue as string}
          localId={localIdValue}
          locais={locais}
          handleChange={this.handleChange}
          validation={agendamentoValidationError}
          criarAgendamento={this.agendar}
          excluirAgendamento={() => this.setState({ modalIsOpen: true })}
          agendamentoRealizado={agendamentoRealizado}
          disabled={Boolean(monografia.agendamento)}
        />
        <DetalhesAgendamentoCard
          membros={membros}
          monografia={monografia}
        />
      </AgendamentoBancaPageWithState>
    );
  }
}
